export const viewWidth = (value: number, viewWidth = 1440) => {
  return (Math.abs(value) / viewWidth) * 100;
};
